import React from "react";
import NavbarComponent from '../component/NavbarComponent'

const Academicsession = () => {
  return (
    <React.Fragment>

    <NavbarComponent />
      <div className="grid lg:grid-cols-5">
        <div className="col-span-2 px-10">
        <div className="py-4 lg:mt-4 mb-2 flex justify-center">
          <span className="text-4xl text-black ">Academic</span>
          <span className="text-4xl text-black font-bold"> Session</span>
        </div>
        <div className="grid grid-row-2 mb-4 border-2 lg:mr-10 lg:ml-10">
          <div className="bg-blue-600 py-2">
            <h6 className="text-white px-2 font-semibold text-left ">
              Academic session period
            </h6>
          </div>
          <div className="text-left">
            <h6 className="text-black px-2  py-2 font-semibold ">
              April to March
            </h6>
          </div>
        </div>
        <div className="grid grid-row-2 lg:mr-10 lg:ml-10 mb-4 mt-4 border-2">
          <div className="bg-[#0ac3fc] py-2">
            <h6 className="text-white px-2 font-semibold text-left ">
              Vacation Period
            </h6>
          </div>
          <div className="text-left">
            <h6 className="text-black px-2  py-2 font-semibold ">
              From 15th May to 14 June
            </h6>
          </div>
        </div>
        <div className="grid grid-row-2 lg:mr-10 lg:ml-10 mb-4 mt-4 border-2">
          <div className="bg-[#548dcc] py-2">
            <h6 className="text-white px-2 font-semibold text-left ">
              Admission Period
            </h6>
          </div>
          <div className="text-left">
            <h6 className="text-black px-2  py-2 font-semibold ">
              April to September
            </h6>
          </div>
        </div>
        </div>
        <div className="py-4 mt-4 mb-2 lg:mr-20 col-span-3">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <div className="text-xl text-center text-white uppercase py-3 bg-[#335377] font-semibold">
              Section Wise enrolment of school for the current session
            </div>
            <table className="min-w-full border text-center">
              <thead className="border-b ">
                <tr className="bg-gray-100">
                  <th className="py-3"> Classes</th>
                  <th className="py-3">Section</th>
                  <th className="py-3">Enrollement</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    I
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    01
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    32
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    II
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    01
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    28
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    III
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    01
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    18
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    IV
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    01
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    16
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    V
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    01
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    40
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    VI
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    02
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    71
                  </td>
                </tr>
                <tr className="border-b">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    VII
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    02
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    80
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    VIII
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    02
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    80
                  </td>
                </tr>
                <tr className="border-b ">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    IX
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    04
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    133
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    X
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    04
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    158
                  </td>
                </tr>
                <tr className="border-b ">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    XI
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    04
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    126
                  </td>
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    XII
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    04
                  </td>
                  <td className="py-3  text-sm font-medium text-gray-900 border-r">
                    157
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <footer className="border-t-2">
     <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span
            className="text-black text-lg font-bold hover:text-blue-300 "
          
          >
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
     </footer>
    </React.Fragment>
  );
};

export default Academicsession;
